// 存放问卷中已经录入的症状

export default {
  SET_USERINFO (state, userInfo) {
    state.userInfo = userInfo || {permissions: []}
    localStorage.setItem('userInfo', JSON.stringify(userInfo))
  },
  SET_TOKEN(state, token) {
    state.token = `Bearer ${token}`
    sessionStorage.setItem('token', state.token)
    localStorage.setItem("token", state.token)
  },
  // RM_SESSION(state) {
  //   state.token = ""
  //   state.userInfo = {}
  //
  //   clearLocalStorage()
  // },
  SET_HIDDEN_HEADER(state, show) {
    state.showHeader = show
  },
  SET_MENU(state, menu) {
    state.menu = menu
  },
  SET_SUBMENU(state, subMenu) {
    state.subMenu = subMenu
  },
  SET_MENU_SUBMENU(state, payload) {
    state.menu = payload.menu
    state.subMenu = payload.subMenu
  },
  SET_BREAD_STYLE(state, style) {
    state.breadStyle = style
    localStorage.setItem('breadStyle', JSON.stringify(style))
  },
  SET_BREAD_LIST(state, list) {
    state.breadList = list
    localStorage.setItem('breadList', JSON.stringify(list))
  },
  SET_LOADDING(state, value) {
    let tip = "加载中..."
    let loading = false

    if(typeof value === 'boolean') {
      loading = value
    } else if(typeof value === 'object') {
      tip = value.tip
      loading = value.loading
    }
    state.globalLoading = {tip, loading}
  },
  DEL_SYMPTOM_VALUE(state, symptomId) {
    state.medcase.symptoms = JSON.parse(JSON.stringify(state.medcase.symptoms)).filter(symptom => symptom.id !== symptomId)
  },
  SET_SYMPTOM_VALUE_ALL(state, symptoms) {
    /* 设置病例症状取值【没有选择的症状不会存在】*/
    state.medcase.symptoms = symptoms
  },
  SET_PROGRESS(state, progress) {
    state.fileProgress = progress
  },
  SET_SYMPTOM_VALUE(state, symptomInfo) {
    // 为了可以监听对象，所以每次更新的时候，使用一个新的地址空间
    let data = JSON.parse(JSON.stringify(state.medcase.symptoms))
    data = data.filter(item => item.id !== symptomInfo.id)

    data.push({
      id: symptomInfo.id,
      info: symptomInfo
    })
    state.medcase.symptoms = data
  },
  SET_SYMPTOM_RELATION(state, relation) {
    state.symptomRelation = relation
  },
  SET_ZHUANBING_VALIDATE_RULE(state, relation) {
    state.zhuanbingValidateRule = relation
  },
  SET_ZHUANBING_VALIDATING(state) {
    state.zhuanbingValidate = !state.zhuanbingValidate
  },
  /* 清除病例数据 */
  DEL_ZHUANBING_DATA(state) {
    state.zhuanbingValidate = false
    state.zhuanbingValidateRule = {}
    state.medcase = {
      info: {},
      symptoms:  [],
      input_diagnose: {},
      check_diagnose: {}
    }
    state.selectedSymptomRelation = {}
  },
  /* 设置当选中症状的时候，影响的症状 */
  SET_SELECTED_SYMPTOM_RELATION(state, symptom_relations) {
    let refineRelations = JSON.parse(JSON.stringify(state.selectedSymptomRelation))
    Object.assign(refineRelations, symptom_relations)
    state.selectedSymptomRelation = refineRelations
  },
  SET_ZHIXIAOYUN_DATA(state, data) {
    state.zhixiaoyunBridge.data = data
    state.zhixiaoyunBridge.loading = false
  },
  SET_ZHIXIAOYUN_SHOW(state, show) {
    state.zhixiaoyunBridge.show = show
  },
  SET_ZHIXIAOYUN_LOADING(state, flag) {
    state.zhixiaoyunBridge.loading = flag
  }
}
